import type { ReactNode } from 'react';

export type PillTone =
  | 'green'
  | 'amber'
  | 'red'
  | 'blue'
  | 'purple'
  | 'gray'
  | 'ctx';

export default function Pill({
  tone = 'gray',
  children,
}: {
  tone?: PillTone;
  children: ReactNode;
}) {
  return <span className={`pill ${tone}`}>{children}</span>;
}
